import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { DialogProvider } from './hooks/useDialog'
import { useTheme } from './hooks/useTheme'
import HomePage from './pages/HomePage'
import EnHomePage from './pages/EnHomePage'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import ProfilePage from './pages/ProfilePage'
import ChangePasswordPage from './pages/ChangePasswordPage'
import ProtectedRoute from './components/ProtectedRoute'

// Apply 活动页面
import { ApplyIndexPage } from './pages/apply/ApplyIndexPage'
import { ApplyRegisterPage } from './pages/apply/ApplyRegisterPage'
import { ApplySuccessPage } from './pages/apply/ApplySuccessPage'

// VIP 页面
import VipHomePage from './pages/vip/VipHomePage'
import VipAboutPage from './pages/vip/VipAboutPage'
import VipContactPage from './pages/vip/VipContactPage'
import VipFaqPage from './pages/vip/VipFaqPage'
import VipProcessPage from './pages/vip/VipProcessPage'
import VipPlatformPage from './pages/vip/VipPlatformPage'

// VIP 服务页面
import ServicesIndexPage from './pages/vip/services/ServicesIndexPage'
import AiCompliancePage from './pages/vip/services/AiCompliancePage'
import BusinessFinancePage from './pages/vip/services/BusinessFinancePage'
import ContentLicensesPage from './pages/vip/services/ContentLicensesPage'
import IntellectualPropertyPage from './pages/vip/services/IntellectualPropertyPage'
import InternetLicensesPage from './pages/vip/services/InternetLicensesPage'

// VIP AI 解决方案页面
import AiSolutionsIndexPage from './pages/vip/ai-solutions/AiSolutionsIndexPage'
import PrivateDeploymentPage from './pages/vip/ai-solutions/PrivateDeploymentPage'
import TrainingAndFinetuningPage from './pages/vip/ai-solutions/TrainingAndFinetuningPage'

// useTheme 依赖 localStorage，SSR 时跳过
const ThemeInit: React.FC = () => {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useTheme()
  }
  return null
}

const AppRoutes: React.FC = () => (
  <DialogProvider>
    <ThemeInit />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/en" element={<EnHomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/change-password" element={<ProtectedRoute><ChangePasswordPage /></ProtectedRoute>} />

      {/* VIP 路由 */}
      <Route path="/vip" element={<VipHomePage />} />
      <Route path="/vip/about" element={<VipAboutPage />} />
      <Route path="/vip/contact" element={<VipContactPage />} />
      <Route path="/vip/faq" element={<VipFaqPage />} />
      <Route path="/vip/process" element={<VipProcessPage />} />
      <Route path="/vip/platform" element={<VipPlatformPage />} />

      {/* VIP 服务中心路由 */}
      <Route path="/vip/services" element={<ServicesIndexPage />} />
      <Route path="/vip/services/ai-compliance" element={<AiCompliancePage />} />
      <Route path="/vip/services/business-finance" element={<BusinessFinancePage />} />
      <Route path="/vip/services/content-licenses" element={<ContentLicensesPage />} />
      <Route path="/vip/services/intellectual-property" element={<IntellectualPropertyPage />} />
      <Route path="/vip/services/internet-licenses" element={<InternetLicensesPage />} />

      {/* VIP AI 解决方案路由 */}
      <Route path="/vip/ai-solutions" element={<AiSolutionsIndexPage />} />
      <Route path="/vip/ai-solutions/private-deployment" element={<PrivateDeploymentPage />} />
      <Route path="/vip/ai-solutions/training-and-finetuning" element={<TrainingAndFinetuningPage />} />

      {/* 祖孙同唱健康歌活动路由 */}
      <Route path="/apply" element={<ApplyIndexPage />} />
      <Route path="/apply/register" element={<ApplyRegisterPage />} />
      <Route path="/apply/success" element={<ApplySuccessPage />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </DialogProvider>
)

export default AppRoutes
